<router-outlet/>

<!-- Cookie banner and the preferences dialog behind the footer link.
     Renders nothing off production hosts (see ConsentService.applies). -->
<app-consent-banner></app-consent-banner>
